import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-service-definition',
  templateUrl: './modify-service-definition.component.html',
  styleUrls: ['./modify-service-definition.component.css']
})
export class ModifyServiceDefinitionComponent implements OnInit {

  data: any;
  cid:any
  planData: any = []
  singlePlanData: any = []
  serviceData: any = []

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllPlans()
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllPlans(){
    this.generic_service.getAllPlans().subscribe(
      (response:any)=>{
        this.planData = response.response;
        console.log(response)
      }
    )
  }

  getAllServices(){
    this.generic_service.getAllServices().subscribe(
      (response:any)=>{
        this.serviceData = response.response;
        console.log(response)
      }
    )
  }

  getPlanById(id:any){
    this.generic_service.getPlanById(id).subscribe(
      (response:any)=>{
        console.log(response)
        console.log(response.response)
        this.singlePlanData = {
          "version": Number(response.response.version),
          "isActive": Boolean(response.response.version),
          "description": String(response.response.description),
          "id": String(response.response.id),
          "planInfoId": Number(response.response.planInfoId),
          "serviceId": Number(response.response.serviceId),
          "name": String(response.response.name),
          "group": String(response.response.group),
          "planImageUrl": String(response.response.planImageUrl),
          "planHeading": String(response.response.planHeading),
          "planSubHeading": String(response.response.planSubHeading),
          "planAmount": Number(response.response.planAmount),
          "oneTimeCharge": Number(response.response.oneTimeCharge),
          "monthlyCharge": Number(response.response.monthlyCharge),
          "usageCharge": Number(response.response.usageCharge),
          "chargeDetail": response.response.chargeDetail,
          "planKeyValue": response.response.planKeyValue,
          "integrationKeyValue": response.response.integrationKeyValue,
          "isPubliclyVisible": Boolean(response.response.isPubliclyVisible),
          "addonPlan": Boolean(response.response.addonPlan),
          "taxIncluded": Boolean(response.response.taxIncluded),
          "taxPercentage": Number(response.response.taxPercentage),
          "taxPrice": Number(response.response.taxPrice),
          "planInfoType": String(response.response.planInfoType),
          "cid": Number(response.response.cid)
        }
      },
      (error)=>{
        console.log(error)
      }
    )
  }

  addP(){
    this.singlePlanData.planKeyValue.push(
      {
        "key": "",
        "value": [""]
      }
    )
  }

  addi(i: any){
    this.singlePlanData.planKeyValue[i].value.push("")
  }

  removeProd(i:any){
    console.log(i)
    this.singlePlanData.planKeyValue.splice(i,1)
  }

  removeValue(i:any,j:any){
    this.singlePlanData.planKeyValue[i].value.splice(j,1)
  }

  addintegration(i: any){
    this.singlePlanData.integrationKeyValue[i].value.push("")
  }
  
  removeintegration(i:any){
    this.singlePlanData.integrationKeyValue.splice(i,1)
  }
  
  removevintegration(i:any,j:any){
    this.singlePlanData.integrationKeyValue[i].value.splice(j,1)
  }

  addvintegration(){
    this.singlePlanData.integrationKeyValue.push(
      {
        "key": "",
        "value": [""]
      }
    )  
  }

  addChargeDetail(){
    this.singlePlanData.chargeDetail.push({
      chargeHeading: '',
      chargeName: '',
      chargeAmount: '',
      chargeType: '',
    })
   }
  
   removeChargeDetail(index: number){
    this.singlePlanData.chargeDetail.splice(index,1)
   }

   updatePlan(){
    let body = {
      "version": Number(this.singlePlanData.version),
      "isActive": Boolean(this.singlePlanData.version),
      "description": String(this.singlePlanData.description),
      "id": String(this.singlePlanData.id),
      "planInfoId": Number(this.singlePlanData.planInfoId),
      "serviceId": Number(this.singlePlanData.serviceId),
      "name": String(this.singlePlanData.name),
      "group": String(this.singlePlanData.group),
      "planImageUrl": String(this.singlePlanData.planImageUrl),
      "planHeading": String(this.singlePlanData.planHeading),
      "planSubHeading": String(this.singlePlanData.planSubHeading),
      "planAmount": Number(this.singlePlanData.planAmount),
      "oneTimeCharge": Number(this.singlePlanData.oneTimeCharge),
      "monthlyCharge": Number(this.singlePlanData.monthlyCharge),
      "usageCharge": Number(this.singlePlanData.usageCharge),
      "chargeDetail": this.singlePlanData.chargeDetail,
      "planKeyValue": this.singlePlanData.planKeyValue,
      "integrationKeyValue": this.singlePlanData.integrationKeyValue,
      "isPubliclyVisible": Boolean(this.singlePlanData.isPubliclyVisible),
      "addonPlan": Boolean(this.singlePlanData.addonPlan),
      "taxIncluded": Boolean(this.singlePlanData.taxIncluded),
      "taxPercentage": Number(this.singlePlanData.taxPercentage),
      "taxPrice": Number(this.singlePlanData.taxPrice),
      "planInfoType": String(this.singlePlanData.planInfoType),
      "cid": Number(this.singlePlanData.cid)
    }

    console.log(this.singlePlanData)
    this.generic_service.updatePlan(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllServices()
        document.getElementById("closeModalButton")?.click()
        this.toastr.success("Successfully Updated");  
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
   }

}